<kendo-dialog [title]="referenceDataLabels.CreditSearch | localizeLabel" (close)="close()" [width]="640">
  <div class="warning-container bo-info-text">
    <h1 class="vo-heading-bold-18 mb-15" [innerHTML]="warningLabel | localizeLabel">
    </h1>

    <div class="pre white-space-pre-line" [innerHTML]="warningContentLabel | localizeLabel"></div>
  </div>

  <kendo-dialog-actions class="modal-buttons">
    <div class="left-column mb-md-0 mb-15">
      <a (click)="close()" [innerHtml]="referenceDataLabels.CancelId|localizeLabel" class="vo-secondary-button-1 link"></a>
    </div>
    <div class="right-column">
      <button (click)="confirm()" [innerHtml]="referenceDataLabels.FinaliseSubmission | localizeLabel"
        class="vo-primary-button-1 primary-button"></button>
    </div>
  </kendo-dialog-actions>
</kendo-dialog>
